import type { ExtensionParams } from '@atlaskit/editor-common/extensions/extension-handler';
import type { Parameters } from '@atlaskit/editor-common/extensions/extension-parameters';
import type { JSONDocNode } from '@atlaskit/editor-json-transformer/types';

import { EXTENSION_KEY, EXTENSION_TYPE } from '../../../extensionConstants.ts';

/**
 * Returns the nested content of the unsupported content extension.
 * @param extensionParams - The extension parameters.
 * @returns The nested content of the unsupported content extension.
 */
export function getUnsupportedContent(
	extensionParams: ExtensionParams<Parameters>,
): JSONDocNode | undefined {
	const { extensionKey, extensionType, parameters } = extensionParams;
	if (extensionKey === EXTENSION_KEY.INVALID && extensionType === EXTENSION_TYPE.MIGRATION) {
		return parameters?.nestedContent;
	}
}
